import * as Sentry from "@sentry/react";
import { hasLtiTabSession } from "@libertify/auth/core";
import { TopBar } from "pages/media/home/components/TopBar";

export const StudioTopBar = () => {
  // LTI (Moodle) tabs hide the user menu.
  if (hasLtiTabSession()) return null;

  return (
    // No fallback, so a crash hides only the top bar.
    <Sentry.ErrorBoundary>
      <TopBar />
    </Sentry.ErrorBoundary>
  );
};
